// extracted by mini-css-extract-plugin
export default {"modal":"Y5-z","sharingIconsV2":"Z5-z","notificationBox":"_5-z","checkMark":"a6-z","textFrame":"b6-z"};